export type FieldType = "toggle" | "number" | "textArea";
export type SourceType = "siteSettings" | "settings";

export interface CustomizationItem {
  key: string;
  label: string;
  description: string;
  source: SourceType;
  fieldType: FieldType;
  apiUrl?: string;
}

export interface CustomizationSectionConfig {
  headerText: string;
  items: CustomizationItem[];
}

export const customizationsConfig: Record<string, CustomizationSectionConfig> = {
  leaderboardSection: {
    headerText: "Leaderboard Settings",
    items: [
      {
        key: "leaderboard",
        label: "Leaderboard",
        description:
          "Show or hide the leaderboard, which contains a sortable list of learners based on points they earn for completing lessons or their security citizen score.",
        source: "siteSettings",
        fieldType: "toggle",
      },
      {
        key: "anonymousLeaderboard",
        label: "Anonymous Leaderboard",
        description:
          "Mask first and last names on the leaderboard. It allows the learner to know where they sit on the leaderboard without knowing the names of any other learners.",
        source: "siteSettings",
        fieldType: "toggle",
      },
      {
        key: "participationEditing",
        label: "Allow a user to opt-in or opt-out of leaderboard.",
        description:
          "When enabled, provides the learner with the individual option to opt-out of the leaderboard, from the user profile.",
        source: "siteSettings",
        fieldType: "toggle",
      },
    ],
  },
  userRestrictions: {
    headerText: "User Permissions",
    items: [
      {
        key: "sjPathsActivated",
        label: "Activate Default Paths",
        description: "Activate or deactivate automatic updates of default paths.",
        source: "siteSettings",
        fieldType: "toggle",
      },
      {
        key: "strictAssignment",
        label: "Strict Assignment",
        description:
          "Enable or disable Strict Assignment mode. When enabled, learners must complete their Assignment before accessing any other content within the platform.",
        source: "siteSettings",
        fieldType: "toggle",
      },
      {
        key: "allowUserProfileEdits",
        label: "Allow User Property Editing in the Platform",
        description:
          "When enabled, user properties will be editable in the platform by learners. Please note that if you are managing learners via SCIM, SSO or CSV upload, these syncs will override any manual changes made in the platform.",
        source: "siteSettings",
        fieldType: "toggle",
      },
    ],
  },
  lessonsSettings: {
    headerText: "Lesson Settings",
    items: [
      {
        key: "rankingQuestions",
        label: "Learning Swing Questions",
        description:
          "Learning swing questions are shown to the learner before and after each module. With this setting off, the learner will not see those questions.",
        source: "siteSettings",
        fieldType: "toggle",
      },
      {
        key: "numberOfTries",
        label: "Number of tries",
        description:
          "Learning swing questions are shown to the learner before and after each module. With this setting off, the learner will not see those questions.",
        source: "settings",
        fieldType: "number",
        apiUrl: "set",
      },
      {
        key: "dojoPreviewVideoId",
        label: "Intro Video",
        description: "Replace the introduction video shown in the Champion Passport.",
        source: "siteSettings",
        fieldType: "toggle",
      },
    ],
  },
  contactSettings: {
    headerText: "Contact Settings",
    items: [
      {
        key: "contacts",
        label: "Security Contact",
        description: "If provided, users can see the Security Contact in the platform menu.",
        source: "siteSettings",
        fieldType: "textArea",
      },
      {
        key: "disclaimerText",
        label: "Disclaimer",
        description:
          "If provided, users can see the Disclaimer in the Notes section before they enter any personal notes.",
        source: "siteSettings",
        fieldType: "textArea",
      },
    ],
  },
};
